<div class="row row--primary">
  <div class="col-12 mt-2">
    <teilrecht-back-link (back)="back()" label="teilrecht-page.teilrecht-summary.link-back" />
  </div>
  @if (model?.directivePreview) {
    <div class="row row--primary tile">
      <div class="col-12 mt-2 opacity-container" [class.active]="model.directivePreview">
        <div class="row mb-2">
          <div class="col-12 mb-4">
            <h5
              [innerHTML]="
                'teilrecht-page.teilrecht-summary.title'
                  | transloco
                    : {
                        name: model.directivePreview.bzrBezeichnung,
                        isin: model.directivePreview.bzrIsin,
                      }
              "
            >
              &nbsp;
            </h5>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-8">{{ 'teilrecht-page.teilrecht-summary.rights-portfolio' | transloco }}</div>
          <div class="col-sm-4 font-bold text-right">{{ model.directivePreview.verfuegbareBzr | number: '1.0-3' }}</div>
        </div>
        @if (model.directivePreview.bezugBzr) {
          <div class="row mt-3">
            <div class="col-sm-8">{{ 'teilrecht-page.teilrecht-summary.rights-buy' | transloco }}</div>
            <div class="col-sm-4 font-bold text-right">
              @if (model.directivePreview.bezugBzr) {
                {{ model.directivePreview.bezugBzr | number: '1.0-3' }}
              } @else {
                &mdash;
              }
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm-8">{{ 'teilrecht-page.teilrecht-summary.rights-value' | transloco }}</div>
            <div class="col-sm-4 font-bold text-right">
              @if (model.directivePreview.bezugBzrWertSumme) {
                {{ model.directivePreview.bezugBzrWertSumme | currency: 'EUR' : 'symbol' : '1.2' }}
              } @else {
                &mdash;
              }
              @if (model.directivePreview.bzrPreisZeitpunkt && model.directivePreview.bezugBzrWertSumme) {
                <div class="font-size-smaller2">({{ model.directivePreview.bzrPreisZeitpunkt | todayTimeOrDate }})</div>
              }
            </div>
          </div>
          @if (model.directivePreview.bezugAktien) {
            <div class="row mt-3">
              <div class="col-sm-8">
                {{ 'teilrecht-page.teilrecht-summary.share-buy' | transloco }} {{ model.directivePreview.bezugAktieBezeichnung }} ({{
                  model.directivePreview.bezugAktieIsin
                }})
              </div>
              <div class="col-sm-4 font-bold text-right">
                {{ model.directivePreview.bezugAktien | number: '1.0-3' }}
              </div>
            </div>
          }
        } @else {
          <div class="row mt-3">
            <div class="col-sm-8">{{ 'teilrecht-page.teilrecht-summary.rights-value' | transloco }}</div>
            <div class="col-sm-4 font-bold text-right">
              @if (model.directivePreview.verkaufBzrWertSumme) {
                {{ model.directivePreview.verkaufBzrWertSumme | currency: 'EUR' : 'symbol' : '1.2' }}
              } @else {
                &mdash;
              }
              @if (model.directivePreview.bzrPreisZeitpunkt && model.directivePreview.verkaufBzrWertSumme) {
                <div class="font-size-smaller2">({{ model.directivePreview.bzrPreisZeitpunkt | todayTimeOrDate }})</div>
              }
            </div>
          </div>
        }
        <div class="row mt-3">
          <div class="col-12">
            <web-components-trading-session (authorizationState)="sessionAuthState($event)" />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-12 d-flex justify-content-center">
            <web-design-system-button
              data-zid="place-directive-button"
              (click)="clicked = true; placeDirective()"
              [disabled]="clicked || !sessionAuthorized"
            >
              <span
                [innerHTML]="
                  (model.directivePreview.bezugBzr
                    ? ('teilrecht-page.teilrecht-summary.link-submit-buy' | transloco)
                    : ('teilrecht-page.teilrecht-summary.link-submit-sell' | transloco)
                  ) | uppercase
                "
              ></span
            ></web-design-system-button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
